export default {"src":"/uk/_next/static/media/errorIcon.27421e93.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};